export default "/app/global-wrapper-client/static/e242e7fca0c5ecc997477663a5af863e.ttf";